//extracted by mini-css-extract-plugin
export default {"closeBtn":"styles_closeBtn__zvwkb","description":"styles_description__M4QGz"};;